<template>
  <v-card v-if="model && model.id" width="100%" tile elevation="0">
    <v-tabs v-model="tab" background-color="primary" dark>
      <v-tab>Jornadas</v-tab>
      <v-tab>Tabla General</v-tab>
      <v-tab>Goleo</v-tab>
      <v-tab>Liguilla</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <!-- General -->
      <v-tab-item>
        <v-card width="auto" outlined>
            <v-card-text>
              <v-row dense>
                  <v-col cols="3" sm="3" md="3">
                      <label class="font-weight-bold subtitle-1 text--primary">LIGA: </label>
                      <p class="font-weight-bold text--secondary">
                          {{ model.nombre }}
                      </p>
                  </v-col>
                  <v-col cols="3" sm="3" md="3">
                      <label class="font-weight-bold subtitle-1 text--primary">Max. de Equipos: </label>
                      <p class="font-weight-bold text--secondary">
                          {{ model.descripcion.maxteam }}
                      </p>
                  </v-col>
                  <v-col cols="3" sm="3" md="3">
                      <label class="font-weight-bold subtitle-1 text--primary">Max. Jug. Equipo: </label>
                      <p class="font-weight-bold text--secondary">
                          {{ model.descripcion.maxplayer }}
                      </p>
                  </v-col>
                  <v-col cols="2" sm="2" md="2" class="text-right">
                    <v-btn
                      v-if="ValidateOnlyPermiss('') && todosLosResultadosCompletos && !liguillaYaGenerada"
                      color="indigo darken-1"
                      @click="liguilla(model)"
                      class="my-custom-btn"
                    >
                      Liguilla
                    </v-btn>
                  </v-col>
                  <v-col cols="2" sm="2" md="2">
                    <v-select
                      v-model="selectedTipoJornada"
                      :items="tiposJornada"
                      item-text="text"
                      item-value="value"
                      label="Tipo Jornada"
                      dense
                      outlined
                      class="mb-4"
                      style="max-width: 140px;"
                    ></v-select>
                  </v-col>
                  <v-col cols="3" sm="3" md="3">
                    <v-select
                  v-model="selectedJornada"
                  :items="jornadasList"
                  label="Seleccionar Jornada"
                  dense
                  outlined
                  class="mb-4"
                   style="max-width: 140px;"
                ></v-select>
                  </v-col>
                  <v-col cols="12" sm="12" md="12" class="scroll-box">
                                    <!-- Select para filtrar por jornada -->
                    <label class="font-weight-bold subtitle-1 text--primary">Jornadas: </label>
                    <v-simple-table fixed-header dense>
                <thead>
                  <tr>
                    <th class="text-center">Jornada</th>
                    <th class="text-center">Tipo</th>
                    <th class="text-center">Equipo Local</th>
                    <th class="text-center">Goles Local</th>
                    <th class="text-center"></th>
                    <th class="text-center">Equipo Visitante</th>
                    <th class="text-center">Goles visitante</th>
                    <th class="text-center">Acciones</th> <!-- Nueva columna de Acciones -->
                  </tr>
                </thead>
                <tbody>
                    <tr v-for="(p) in filteredJornadas" :key="p.id">
                      <td class="text-center player-cell">{{ p.numero_jornada }}</td>
                      <td class="text-center player-cell">{{ p.tipo }}</td>
                      <td class="text-center player-cell">{{ p.equipo_local?.equipo || p.equipo_local_id }}</td>
                      <td class="text-center player-cell">{{ p.resul_local }}</td>
                      <td class="text-center player-cell"> VS </td>
                      <td class="text-center player-cell">{{ p.equipo_visitante?.equipo || p.equipo_visitante_id }}</td>
                      <td class="text-center player-cell">{{ p.resul_visitante }}</td>
                      <td class="text-center player-cell">
                        <v-menu
                        v-if="p.equipo_local_id !== 'Descansa' && p.equipo_visitante_id !== 'Descansa'"
                         bottom right>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn dark v-bind="attrs" v-on="on" color="indigo darken-1">
                              <v-icon>mdi-cog</v-icon>
                            </v-btn>
                          </template>
                          <v-list>
                            <v-list-item
                              v-if="ValidateOnlyPermiss('ligas.marcador') && p.equipo_local_id !== 'Descansa' && p.equipo_visitante_id !== 'Descansa'"
                              @click="Marcador(p)">
                              <v-list-item-title>Marcador</v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="generarListaPDF(p)">
                              <v-list-item-title>🖨️ Descargar Lista</v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="generarCedulaPDF(p)">
                              <v-list-item-title>🖨️ Descargar Cédula</v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </td>
                    </tr>
                  </tbody>
              </v-simple-table>
                </v-col>
              </v-row>
                  <v-dialog v-model="showPDFModal" max-width="70%">
      <v-card>
        <v-card-title class="headline">Documento PDF</v-card-title>
        <v-card-text>
          <!-- Mostrar el PDF en un iframe -->
          <iframe v-if="pdfUrl" :src="pdfUrl" width="100%" height="430px"></iframe>
          <p v-else>No se pudo cargar el PDF.</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" text @click="showPDFModal = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
            </v-card-text>
        </v-card>
      </v-tab-item>
            <!-- Tabla General -->
            <v-tab-item>
        <v-card width="auto" outlined>
            <v-card-text>
              <v-row dense>
                  <v-col cols="2" sm="2" md="2">
                      <label class="font-weight-bold subtitle-1 text--primary">LIGA: </label>
                      <p class="font-weight-bold text--secondary">
                          {{ model.nombre }}
                      </p>
                  </v-col>
                  <v-col cols="2" sm="2" md="2" class="text-right">
                    <v-btn
                      v-if="ValidateOnlyPermiss('ligas.tabla')"
                      color="indigo darken-1"
                      @click="Tabla(model)"
                      class="my-custom-btn"
                    >
                      Ver Tabla
                    </v-btn>
                  </v-col>
                  <v-col cols="2" sm="2" md="2" class="text-right">
                    <v-btn
                      color="green darken-2"
                      class="my-custom-btn"
                      @click="descargarPDF(model)"
                    >
                      PDF
                    </v-btn>
                  </v-col>
                  <v-col cols="6" sm="12" md="12" class="scroll-box">
                                    <!-- Select para filtrar por jornada -->
                    <label class="font-weight-bold subtitle-1 text--primary">TABLA GENERAL: </label>
                    <v-simple-table fixed-header dense>
                <thead>
                  <tr>
                    <th class="text-center">Posicion</th>
                    <th class="text-center">Equipo</th>
                    <th class="text-center">PJ</th>
                    <th class="text-center">G</th>
                    <th class="text-center">E</th>
                    <th class="text-center">P</th>
                    <th class="text-center">GF</th>
                    <th class="text-center">GC</th>
                    <th class="text-center">Dif. Goles</th>
                    <th class="text-center">Puntos</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(team, index) in tablaGeneral" :key="index">
                  <td class="text-center">{{ index + 1 }}</td> <!-- Posición basada en el índice -->
                  <td class="text-center">{{ JSON.parse(team.equipo).equipo }}</td> <!-- Nombre del equipo -->
                  <td class="text-center">{{ team.partidos_jugados }}</td>
                  <td class="text-center">{{ team.partidos_ganados }}</td>
                  <td class="text-center">{{ team.partidos_empatados }}</td>
                  <td class="text-center">{{ team.partidos_perdidos }}</td>
                  <td class="text-center">{{ team.goles_a_favor }}</td>
                  <td class="text-center">{{ team.goles_en_contra }}</td>
                  <td class="text-center">{{ team.diferencia_goles }}</td>
                  <td class="text-center">{{ team.puntos }}</td> <!-- Puntos del equipo -->
                </tr>
                  </tbody>
              </v-simple-table>
                </v-col>
              </v-row>
            </v-card-text>
        </v-card>
      </v-tab-item>

     <!-- Goleo -->
            <v-tab-item>
        <v-card width="auto" outlined>
            <v-card-text>
              <v-row dense>
                                  <v-col cols="2" sm="2" md="2">
                      <label class="font-weight-bold subtitle-1 text--primary">LIGA: </label>
                      <p class="font-weight-bold text--secondary">
                          {{ model.nombre }}
                      </p>
                  </v-col>
                  <v-col cols="2" sm="2" md="2" class="text-right">
                    <v-btn
                      v-if="ValidateOnlyPermiss('ligas.goleo')"
                      color="indigo darken-1"
                      @click="Goleadores(model)"
                      class="my-custom-btn"
                    >
                      Ver Goleo
                    </v-btn>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
<v-simple-table dense>
  <thead>
    <tr>
      <th class="text-center">#</th>
      <th class="text-center">Jugador</th>
      <th class="text-center">Equipo</th>
      <th class="text-center">Goles</th>
    </tr>
  </thead>
  <tbody>
    <tr v-for="(jugador, index) in goleadores" :key="jugador.id">
      <td class="text-center">{{ index + 1 }}</td>
      <td class="text-align">{{ jugador.nombre }}</td>
      <td class="text-center">{{ jugador.equipo }}</td>
      <td class="text-center">{{ jugador.goles }}</td>
    </tr>
  </tbody>
</v-simple-table>
                </v-col>
              </v-row>
            </v-card-text>
        </v-card>
      </v-tab-item>

      <!-- Liguilla -->
      <v-tab-item>
        <v-card width="auto" outlined>
            <v-card-text>
              <v-row dense>
                  <v-col cols="3" sm="3" md="3">
                      <label class="font-weight-bold subtitle-1 text--primary">LIGA: </label>
                      <p class="font-weight-bold text--secondary">
                          {{ model.nombre }}
                      </p>
                  </v-col>
                  <v-col cols="6" sm="6" md="6" class="text-right">
                    <v-btn
                      v-if="ValidateOnlyPermiss('') && todosLosResultadosCompletos && !semisYaGenerada"
                      color="indigo darken-1"
                      @click="generarSemifinales(model)"
                      class="my-custom-btn2"
                    >
                      Generar Semis
                    </v-btn>
                  </v-col>
                  <v-col cols="2" sm="2" md="2" class="text-right">
                    <v-btn
                      v-if="ValidateOnlyPermiss('') && todosLosResultadosCompletos && !finalYaGenerada"
                      color="indigo darken-1"
                      @click="generarFinal(model)"
                      class="my-custom-btn2"
                    >
                      Generar Final
                    </v-btn>
                  </v-col>
                  <v-col cols="2" sm="2" md="2">
                    <v-select
                      v-model="selectedTipoJornada"
                      :items="tiposJornadaliguilla"
                      label="Tipo Jornada"
                      dense
                      outlined
                      class="mb-4"
                      style="max-width: 140px;"
                    ></v-select>
                  </v-col>
                  <v-col cols="2" sm="2" md="2">
                    <v-select
                  v-model="selectedJornada"
                  :items="jornadasList"
                  label="Seleccionar Jornada"
                  dense
                  outlined
                  class="mb-4"
                   style="max-width: 140px;"
                ></v-select>
                  </v-col>
                  <v-col cols="12" sm="12" md="12" class="scroll-box">
                                    <!-- Select para filtrar por jornada -->
                    <label class="font-weight-bold subtitle-1 text--primary">Jornadas: </label>
                    <v-simple-table fixed-header dense>
                <thead>
                  <tr>
                    <th class="text-center">Jornada</th>
                    <th class="text-center">Tipo</th>
                    <th class="text-center">Equipo Local</th>
                    <th class="text-center">Goles Local</th>
                    <th class="text-center"></th>
                    <th class="text-center">Equipo Visitante</th>
                    <th class="text-center">Goles visitante</th>
                    <th class="text-center">Acciones</th> <!-- Nueva columna de Acciones -->
                  </tr>
                </thead>
                <tbody>
                    <tr v-for="(p) in filteredJornadas" :key="p.id">
                      <td class="text-center player-cell">{{ p.numero_jornada }}</td>
                      <td class="text-center player-cell">{{ p.tipo }}</td>
                      <td class="text-center player-cell">{{ p.equipo_local?.equipo || p.equipo_local_id }}</td>
                      <td class="text-center player-cell">{{ p.resul_local }}</td>
                      <td class="text-center player-cell"> VS </td>
                      <td class="text-center player-cell">{{ p.equipo_visitante?.equipo || p.equipo_visitante_id }}</td>
                      <td class="text-center player-cell">{{ p.resul_visitante }}</td>
                      <td class="text-center player-cell">
                        <v-menu
                        v-if="p.equipo_local_id !== 'Descansa' && p.equipo_visitante_id !== 'Descansa'"
                         bottom right>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn dark v-bind="attrs" v-on="on" color="indigo darken-1">
                              <v-icon>mdi-cog</v-icon>
                            </v-btn>
                          </template>
                          <v-list>
                            <v-list-item
                              v-if="ValidateOnlyPermiss('ligas.marcador') && p.equipo_local_id !== 'Descansa' && p.equipo_visitante_id !== 'Descansa'"
                              @click="Marcador(p)">
                              <v-list-item-title>Marcador</v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="generarListaPDF(p)">
                              <v-list-item-title>🖨️ Descargar Lista</v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="generarCedulaPDF(p)">
                              <v-list-item-title>🖨️ Descargar Cédula</v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </td>
                    </tr>
                  </tbody>
              </v-simple-table>
                </v-col>
              </v-row>
            </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
<v-dialog v-model="showCedulaModal" max-width="750px" scrollable>
  <v-card style="max-height: 90vh; display: flex; flex-direction: column;">
    <v-card-title class="headline">📋 Cédula del Partido</v-card-title>

    <v-tabs v-model="cedulaTab" background-color="primary" dark>
      <v-tab>Equipo Local</v-tab>
      <v-tab>Equipo Visitante</v-tab>
    </v-tabs>

    <!-- Aquí envolvemos todo el contenido desplazable -->
    <div style="overflow-y: auto; max-height: 60vh;">
      <v-tabs-items v-model="cedulaTab">
        <!-- LOCAL -->
        <v-tab-item>
          <v-card flat>
            <v-card-title class="subtitle-4 font-weight-bold d-flex justify-center" style="color: #2074d4;">
              {{ selectedMatch.equipo_local?.equipo }}
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <v-simple-table dense>
              <thead>
                <tr>
                  <th>Nombre</th>
                  <th >Goles</th>
                  <th >Amarillas</th>
                  <th >Rojas</th>
                  <th >Asistió</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="jugador in jugadoresLocal" :key="jugador.id" class="py-1">
                  <td class="text-lg font-medium">{{ jugador.NombreCompleto }}</td>
                  <td class="text-center">
                    <v-text-field v-model="jugador.goles" type="number" dense hide-details solo flat style="width: 60px;"></v-text-field>
                  </td>
                  <td class="text-center">
                    <v-text-field v-model="jugador.amarillas" type="number" dense hide-details solo flat style="width: 60px;"></v-text-field>
                  </td>
                  <td class="text-center">
                    <v-text-field v-model="jugador.rojas" type="number" dense hide-details solo flat style="width: 60px;"></v-text-field>
                  </td>
                  <td class="text-center">
                    <v-checkbox v-model="jugador.asistio" dense hide-details></v-checkbox>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <!-- VISITANTE -->
        <v-tab-item>
          <v-card flat>
            <v-card-title class="subtitle-4 font-weight-bold d-flex justify-center" style="color: #2074d4;">
              {{ selectedMatch.equipo_visitante?.equipo }}
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
               <v-simple-table dense>
              <thead>
                <tr>
                  <th>Nombre</th>
                  <th >Goles</th>
                  <th >Amarillas</th>
                  <th >Rojas</th>
                  <th >Asistió</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="jugador in jugadoresVisitante" :key="jugador.id" class="py-1">
                  <td class="text-lg font-medium">{{ jugador.NombreCompleto }}</td>
                  <td class="text-center">
                    <v-text-field v-model="jugador.goles" type="number" dense hide-details solo flat style="width: 60px;"></v-text-field>
                  </td>
                  <td class="text-center">
                    <v-text-field v-model="jugador.amarillas" type="number" dense hide-details solo flat style="width: 60px;"></v-text-field>
                  </td>
                  <td class="text-center">
                    <v-text-field v-model="jugador.rojas" type="number" dense hide-details solo flat style="width: 60px;"></v-text-field>
                  </td>
                  <td class="text-center">
                    <v-checkbox v-model="jugador.asistio" dense hide-details></v-checkbox>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </div>

    <v-divider class="my-2"></v-divider>

    <v-card-actions class="justify-end">
            <!-- <v-btn color="primary" dark @click="generarListaPDF">
        🖨️ Descargar Lista
      </v-btn>
      <v-btn color="primary" dark @click="generarCedulaPDF">
        🖨️ Descargar Cedula
      </v-btn> -->
      <v-btn color="primary" dark @click="guardarCedula">
        💾 Guardar Cédula
      </v-btn>
      <v-btn color="grey darken-1" dark @click="showCedulaModal = false">
        ❌ Cerrar
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

  </v-card>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { Permission } from '@/mixins/permissionMain'
import axios from 'axios'

// import ViewMovementsField from '@/components/fields/specific/ViewMovementsField'
export default {
  props: ['model', 'onSuccess'],
  name: 'JornadaDetails',
  mixins: [Permission],
  data: () => ({
    finalPuedeGenerarse: false,
    tablaGeneral: [],
    goleadores: [],
    pdfUrl: null,
    showPDFModal: false,
    userPermissions: [],
    tab: 0,
    editDialog: false,
    itemInsumos: {},
    familia: null,
    selectedMatch2: {
      resul_local: 0,
      resul_visitante: 0
    },
    showCedulaModal: false,
    cedulaTab: 0, // Maneja pestañas
    selectedMatch: {},

    // Jugadores del equipo local y visitante
    jugadoresLocal: [],
    jornadas: [],
    jugadoresVisitante: [],
    selectedJornada: null,
    tiposJornada: ['ida', 'vuelta'],
    tiposJornadaliguilla: ['cuartos', 'semis', 'final'],
    selectedTipoJornada: null,
    movs: {
      field: 'showMovsDataServer',
      name: '',
      nameid: 'movimientos',
      url: '/procesos/movimientos',
      default: '/procesos/movimientos',
      hidden: true,
      cols: 12
    },
    showMovs: true
  }),
  components: {
    // ViewMovementsField
  },
  verificarFinal () {
    axios.get('/empresa/ligas/final-puede-generarse', {
      params: { liga_id: this.model.id }
    }).then(res => {
      this.finalPuedeGenerarse = res.data.final_puede_generarse
    })
  },
  methods: {
    ...mapActions(['urlGetServiceActionTwoo', 'getUrlServices', 'GETObjects', 'POSTPagination']),
    ...mapMutations(['SHOW_DIALOG_MAIN', 'SHOW_DIALOG_ALERT_MAIN']),
    sendEvent (item) {
      this.onSuccess(item)
    },
    viewMovs (folio) {
      this.showMovs = false
      this.movs.url = `${this.movs.default}?folio=${folio}&mov=all`
      setTimeout(() => { this.showMovs = true }, 200)
    },
    ValidateOnlyPermiss (permiso) {
      const permisos = JSON.parse(localStorage.getItem('permisos')) || []
      return this.ReadOnlyPermiso(permisos, permiso)
    },
    Goleadores (item) {
      console.log('item', item) // Verifica el contenido de item

      const ligaId = item.torneo[0].id // Asegúrate de que el ID de la liga esté presente

      this.urlGetServiceActionTwoo({
        url: `${this.get_urls['ligas.goleo']}?liga_id=${ligaId}` // Usa el alias definido en get_urls
      })
        .then((response) => {
          console.log('Goleadores:', response) // Muestra los goleadores
          this.goleadores = response // Guarda los datos en tu array goleadores
        })
        .catch((error) => {
          console.error('Error al cargar los goleadores:', error)
        })
    },
    openEditDialog (match) {
      if (!match || !match.id) {
        console.error('El objeto match no es válido:', match)
        return
      }
      this.selectedMatch = { ...match } // Copia el objeto
      this.editDialog = true // Abre el modal
    },
    async Marcador (match) {
      this.selectedMatch = match
      const jugadoresLocal = await this.obtenerJugadores(match.equipo_local_id)
      const jugadoresVisitante = await this.obtenerJugadores(match.equipo_visitante_id)

      // Obtener cédula guardada por jornada_id
      const token = this.$cookies.get('token')
      const header = { Authorization: `Bearer ${token}` }
      let cedulaGuardada = []

      try {
        const response = await axios.get(`/empresa/ligas/marcador/${match.id}`, { headers: header })
        cedulaGuardada = response.data
      } catch (error) {
        console.warn('No hay cédula previa:', error)
      }

      // Mapear datos de los jugadores locales
      this.jugadoresLocal = jugadoresLocal.map(jugador => {
        const cedula = cedulaGuardada.find(c => c.jugador_id === jugador.id)
        return {
          ...jugador,
          asistio: cedula ? cedula.asistio === 1 : false,
          goles: cedula ? cedula.goles : 0,
          amarillas: cedula ? cedula.amarillas : 0,
          rojas: cedula ? cedula.rojas : 0
        }
      })

      // Mapear datos de los jugadores visitantes
      this.jugadoresVisitante = jugadoresVisitante.map(jugador => {
        const cedula = cedulaGuardada.find(c => c.jugador_id === jugador.id)
        return {
          ...jugador,
          asistio: cedula ? cedula.asistio === 1 : false,
          goles: cedula ? cedula.goles : 0,
          amarillas: cedula ? cedula.amarillas : 0,
          rojas: cedula ? cedula.rojas : 0
        }
      })

      this.showCedulaModal = true
    },
    async obtenerJugadores (equipoId) {
      try {
        // Realizar la llamada a la API de Laravel
        const token = this.$cookies.get('token')
        const header = { Authorization: `Bearer ${token}` }
        const response = await axios.get(`/empresa/ligas/jugadores/${equipoId}`, { headers: header })
        // Obtener los jugadores
        const jugadores = response.data
        return jugadores
      } catch (error) {
        console.error('Error al obtener los jugadores:', error)
        return [] // Retorna un array vacío en caso de error
      }
    },
    guardarCedula () {
      console.log('match', this.selectedMatch)
      const jugadoresLocalAsistieron = this.jugadoresLocal.filter(j => j.asistio)
      const jugadoresVisitanteAsistieron = this.jugadoresVisitante.filter(j => j.asistio)

      const data = {
        jornada_id: this.selectedMatch.id,
        equipo_local_id: this.selectedMatch.equipo_local_id,
        equipo_visitante_id: this.selectedMatch.equipo_visitante_id,
        equipoLocal: jugadoresLocalAsistieron,
        equipoVisitante: jugadoresVisitanteAsistieron
      }

      const token = this.$cookies.get('token')
      const header = { Authorization: `Bearer ${token}` }

      axios.post('/empresa/ligas/cedula', data, { headers: header })
        .then(response => {
          console.log('Cédula guardada correctamente')
          this.showCedulaModal = false

          // Sumar goles y asignar a selectedMatch para precargar el marcador
          const golesLocal = jugadoresLocalAsistieron.reduce((total, j) => total + Number(j.goles), 0)
          const golesVisitante = jugadoresVisitanteAsistieron.reduce((total, j) => total + Number(j.goles), 0)

          this.selectedMatch.local = golesLocal
          this.selectedMatch.visitante = golesVisitante

          this.MarcadorFinal()
        })
        .catch(error => {
          console.error('Error al guardar la cédula:', error)
          this.$toast.error('Hubo un error al guardar la cédula')
        })
    },
    MarcadorFinal () {
      console.log('marca', this.selectedMatch)
      this.SHOW_DIALOG_MAIN({
        type: 'create',
        with: '37%',
        title: `Marcador de ${this.selectedMatch.equipo_local.equipo} VS ${this.selectedMatch.equipo_visitante.equipo}`,
        body: {
          objectMain: this.selectedMatch,
          paramsDialog: {
            form: this.get_MarcadorForm,
            url: this.get_urls['ligas.marcador'],
            message: 'Registro Agregado Correctamente',
            setmodel: true,
            updated: true
          }
        }
      })
    },
    async generarCedulaPDF (match) {
      console.log('match', match)
      try {
        const token = this.$cookies.get('token')
        const header = { Authorization: `Bearer ${token}` }

        // Solo envías los datos mínimos necesarios
        const response = await axios.post('/empresa/ligas/cedulapdf', {
          partido_id: match.id,
          liga_id: match.liga_id
        }, { headers: header })

        const pdfBase64 = response.data.pdf

        // Mostrar PDF en modal
        this.pdfUrl = `data:application/pdf;base64,${pdfBase64}`
        this.showPDFModal = true
      } catch (error) {
        console.error('Error generando lista PDF:', error)
      }
    },
    async generarListaPDF (match) {
      console.log('match', match)
      try {
        const token = this.$cookies.get('token')
        const header = { Authorization: `Bearer ${token}` }

        // Solo envías los datos mínimos necesarios
        const response = await axios.post('/empresa/ligas/listapdf', {
          partido_id: match.id,
          liga_id: match.liga_id
        }, { headers: header })

        const pdfBase64 = response.data.pdf

        // Mostrar PDF en modal
        this.pdfUrl = `data:application/pdf;base64,${pdfBase64}`
        this.showPDFModal = true
      } catch (error) {
        console.error('Error generando lista PDF:', error)
      }
    },
    liguilla (item) {
      console.log('item', item)
      this.SHOW_DIALOG_MAIN({
        type: 'create',
        with: '37%',
        title: 'Tipo de liguilla',
        body: {
          objectMain: { liga_id: item.id, torneo_id: item?.torneo[0]?.id },
          paramsDialog: {
            form: this.get_LiguillaForm,
            url: this.get_urls['ligas.liguilla'],
            message: 'Registro Agregado Correctamente',
            setmodel: true,
            updated: true
          }
        }
      })
    },
    async generarSemifinales (item) {
      console.log('item', item)
      try {
        const token = this.$cookies.get('token')
        const header = { Authorization: `Bearer ${token}` }
        const response = await axios.post('/empresa/ligas/generar-semifinales', {
          liga_id: item.id, torneo_id: item.torneo[0].id
        }, { headers: header })
        this.$swal.fire('Éxito', response.data.message, 'success')
      } catch (error) {
        console.error('Error al generar semifinales:', error)
        const mensaje = error.response?.data?.message || 'Ocurrió un error'
        this.$swal.fire('Error', mensaje, 'error')
      }
    },
    // async verificarSemisGeneradas (item) {
    //   console.log('item', this)
    //   try {
    //     const token = this.$cookies.get('token')
    //     const header = { Authorization: `Bearer ${token}` }
    //     const response = await axios.get(`/empresa/ligas/semis/${this.model.id}/semis-existen`, { headers: header })
    //     this.semisGeneradas = response.data.semis_generadas
    //   } catch (error) {
    //     console.error('Error verificando semifinales:', error)
    //   }
    // },
    async generarFinal (item) {
      console.log('item', item)
      try {
        const token = this.$cookies.get('token')
        const header = { Authorization: `Bearer ${token}` }
        const response = await axios.post('/empresa/ligas/generar-final', {
          liga_id: item.id, torneo_id: item.torneo[0].id
        }, { headers: header })
        this.$swal.fire('Éxito', response.data.message, 'success')
      } catch (error) {
        console.error('Error al generar semifinales:', error)
        const mensaje = error.response?.data?.message || 'Ocurrió un error'
        this.$swal.fire('Error', mensaje, 'error')
      }
    },
    Tabla (item) {
      console.log('item', item) // Verifica el contenido de item

      // Asegúrate de que 'item.id' se esté utilizando correctamente
      const ligaId = item.id

      this.urlGetServiceActionTwoo({
        url: `${this.get_urls['ligas.tabla']}?liga_id=${ligaId}` // Construir la URL correctamente
      })
        .then((response) => {
          console.log('Tabla General:', response) // Datos recibidos
          this.tablaGeneral = response // Guarda el resultado en tablaGeneral
        })
        .catch((error) => {
          console.error('Error al cargar la Tabla General:', error)
        })
    },
    descargarPDF (item) {
      console.log('item', item)
      const ligaId = item.id

      this.urlGetServiceActionTwoo({
        url: `/empresa/ligas/tabla-pdf?liga_id=${ligaId}`
      })
        .then((response) => {
          const link = document.createElement('a')
          link.href = 'data:application/pdf;base64,' + response.pdf
          link.download = response.nombre
          link.click()
        })
        .catch((error) => {
          console.error('Error al generar el PDF:', error)
        })
    },
    async cargarJornadasPorTipo (tipo, liga) {
      console.log('ligaid', this.model.id)
      try {
        const token = this.$cookies.get('token')
        const header = { Authorization: `Bearer ${token}` }

        const ligaId = this.model?.id || this.model?.liga_id

        const response = await axios.get('/empresa/ligas/jornadas', {
          headers: header,
          params: {
            liga_id: ligaId,
            tipo: tipo // "ida" o "vuelta"
          }
        })
        console.log(response.data)
        this.jornadas = response.data
      } catch (error) {
        console.error('Error cargando jornadas:', error)
        this.jornadas = []
      }
    }
    // async cargarJornadas (tipo = 'ida') {
    //   console.log('torneo', this.model.torneo)
    //   try {
    //     const token = this.$cookies.get('token')
    //     const header = { Authorization: `Bearer ${token}` }
    //     const response = await axios.get('/empresa/ligas/jornadas', { headers: header }, {
    //       params: {
    //         tipo,
    //         torneo_id: this.torneoId
    //       }
    //     })
    //     this.jornadas = response.data
    //   } catch (error) {
    //     console.error('Error al cargar jornadas:', error)
    //   }
    // }
  },
  computed: {
    liguillaYaGenerada () {
      return Array.isArray(this.jornadas) &&
           this.jornadas.some(j => j.tipo && j.tipo.toLowerCase().includes('cuartos'))
    },
    semisYaGenerada () {
      return Array.isArray(this.jornadas) &&
           this.jornadas.some(j => j.tipo && j.tipo.toLowerCase().includes('semis'))
    },
    finalYaGenerada () {
      return Array.isArray(this.jornadas) &&
           this.jornadas.some(j => j.tipo && j.tipo.toLowerCase().includes('final'))
    },
    // Lista de jornadas únicas para el select
    jornadasList () {
      if (!this.selectedTipoJornada || !this.jornadas) return []
      const filtradas = this.jornadas.filter(
        (j) => j.tipo === this.selectedTipoJornada
      )
      return [...new Set(filtradas.map((j) => j.numero_jornada))]
    },
    todosLosResultadosCompletos () {
      console.log('todos', this.jornadas)
      if (!this.jornadas) return false

      return this.jornadas.every(j =>
        j.equipo_local_id === 'Descansa' ||
        j.equipo_visitante_id === 'Descansa' || (
          j.resul_local !== null &&
          j.resul_local !== '' &&
          j.resul_visitante !== null &&
          j.resul_visitante !== ''
        )
      )
    },

    // Lista de tipos únicos de jornada para el nuevo select
    tiposJornadaList () {
      return this.model.jornadas
        ? [...new Set(this.model.jornadas.map((j) => j.tipo))]
        : []
    },

    // Jornadas filtradas por tipo de jornada
    jornadasFiltradasPorTipo () {
      if (!this.jornadas || !Array.isArray(this.jornadas)) return []
      if (!this.selectedTipoJornada) return this.jornadas
      return this.jornadas.filter(
        (j) => j.tipo === this.selectedTipoJornada
      )
    },

    // Jornadas filtradas según tipo y jornada seleccionada
    filteredJornadas () {
      let jornadas = this.jornadasFiltradasPorTipo

      if (this.selectedJornada !== null && this.selectedJornada !== '') {
        const selected = parseInt(this.selectedJornada)
        jornadas = jornadas.filter((j) => parseInt(j.numero_jornada) === selected)
      }
      console.log('Selected:', this.selectedJornada)
      console.log('Filtradas:', jornadas)
      return jornadas.sort((a, b) => a.numero_jornada - b.numero_jornada)
    },
    ...mapGetters(['get_urls', 'get_object', 'get_DocumentForm', 'get_InvalideForm', 'get_MarcadorForm', 'get_LiguillaForm'])
  },
  mounted () {
    this.cargarJornadasPorTipo(this.selectedTipoJornada)
  },
  watch: {
    model (obj) {
      this.tab = 0
    },
    get_object (val) {
      if (val) {
        this.familia = val
      }
    },
    selectedTipoJornada (newTipo) {
      this.cargarJornadasPorTipo(newTipo)
    }
  }
}
</script>

<style>
  .player-cell {
    padding-top: 5px !important;
    padding-bottom: 5px !important; /* Ajusta el tamaño de padding según sea necesario */
}
  .my-custom-btn {
    width: 120px;
    color: white !important; /* Color del texto */
    padding: 0px; /* Relleno */
    border-radius: 5%; /* Borde redondeado */
}

  .my-custom-btn:hover {
    background-color: #f50057; /* Color al pasar el mouse */
}

.my-custom-btn2 {
    width: 135px;
    color: white !important; /* Color del texto */
    padding: 0px; /* Relleno */
    border-radius: 5%; /* Borde redondeado */
}

  .my-custom-btn2:hover {
    background-color: #f50057; /* Color al pasar el mouse */
}
</style>
